<template>
  <div class="scroller-item" :latitude="this.latitude.replace('+','').replace('°','')" v-bind:style="{ left: `${offset}px`, zIndex: zIndex }">
    <span class="scroller-item__text" v-bind:class="[ 
        ( (selected || viewing) )?'selected-stream':'',
        ( (selected || viewing) )?'feature-'+stream.attributes.featureCode:'',
      ]">
      <div v-if="stream.attributes.soundcamp == false" class="scroller-item__dot" :class="['feature-'+stream.attributes.featureCode]"></div>
      <div v-else class="scroller-item__triangle" :class="['feature-'+stream.attributes.featureCode]"></div>
      <span>{{ location }}</span>
    </span>
  </div>
</template>

<script>

export default {
  name: 'ScrollerItem',
  props: ['endTime', 'startTime', 'stream', 'width', 'playing', 'playingId','id','latitude','selected','viewing'],
  data() {
    const duration = this.endTime - this.startTime;
    const reductionFactor = (this.width - 1400) / duration;
    const compStartTime = this.stream.attributes.comparableStartTime;
    const location = this.stream.attributes.location;
    const test = 4;

    return {
      offset: (((this.endTime - compStartTime) * reductionFactor)),
      zIndex: this.endTime - compStartTime,
      location: location, // location: location.length > 35 ? `${location.replace(/^(.{31}[^\s,]*).*/, '$1')}…` : location,
    };
  },
  computed: {
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/ScrollerItem.vue